import { render, staticRenderFns } from "./voteDetails.vue?vue&type=template&id=782e709d"
import script from "./voteDetails.vue?vue&type=script&lang=js"
export * from "./voteDetails.vue?vue&type=script&lang=js"
import style0 from "./voteDetails.vue?vue&type=style&index=0&id=782e709d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports